import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import * as Icons from 'lucide-react';

const CategoryCard = ({ category, className }) => {
  const { getLocalizedField } = useLanguage();
  const navigate = useNavigate();

  const name = getLocalizedField(category, 'name');
  const IconComponent = Icons[category.icon] || Icons.MapPin;

  return (
    <div
      className={`relative overflow-hidden aspect-square flex items-end p-4 cursor-pointer group ${className}`}
      onClick={() => navigate(`/explore?category=${category.slug}`)}
      data-testid={`category-card-${category.slug}`}
    >
      {/* Background image */}
      <img
        src={category.image}
        alt={name}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
      />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
      
      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="flex items-center gap-2 mb-1">
          <IconComponent size={20} className="text-white" />
          <h3 className="text-white font-bold text-lg">{name}</h3>
        </div>
        {category.places_count > 0 && (
          <p className="text-white/70 text-sm">
            {category.places_count} lugares
          </p>
        )}
      </div>
    </div>
  );
};

export default CategoryCard;
